@if (!!value || showFieldAsEdit) {
  <div
    class="field"
    >
    <div
      fxlayout="row"
      fxLayoutAlign="space-between center">
      <div>
        <label class="upper">{{ displayName }}</label>
      </div>
      <div>
        @if (isOverflow && !_isEdit) {
          <div
            class="popout-button">
            <button
              type="button"
              class="button is-ghost is-small"
              (click)="showMultilineDialog()">
              <i
                class="icon icon-new_window"
              style="font-size: 18px; color: var(--color-grey-6)"></i>
            </button>
          </div>
        }
      </div>
    </div>
    @if (showFieldAsEdit) {
      <div
        style="display: block"
        >
        @if (format === TextFieldFormat.SingleLine) {
          <input
            [(ngModel)]="_value"
            (ngModelChange)="onValueChanged()"
            class="input is-small is-fullwidth"
            id="{{ fieldUId }}"
            name="{{ fieldUId }}"
            type="text"
            [placeholder]="displayName" />
        }
        @if (format === TextFieldFormat.MultiLine) {
          <div
            class="edit-panel-multiline"
            >
            <quill-editor
              [styles]="{ height: '104px' }"
              [modules]="editorModules"
              placeholder="{{ 'FIELDS.START-TYPING-HERE' | translate }}"
              [(ngModel)]="_value"
              (onContentChanged)="onContentChanged($event)"
            (onEditorCreated)="editorCreated($event)"></quill-editor>
          </div>
        }
      </div>
    }
    @if (!showFieldAsEdit) {
      <div
        style="display: block"
        >
        @if (format === TextFieldFormat.SingleLine) {
          <div
            class="is-readonly"
            >
            {{ valueForDisplay | formatLongText: 100 }}
          </div>
        }
        @if (format === TextFieldFormat.MultiLine) {
          <div
            class="multiline-container"
            >
            @if (_value?.length > 0) {
              <div
                class="is-readonly is-multiline ngx-quill-view"
                #multilineReadonly>
                <div class="ql-editor" [innerHTML]="_value | safeHtml"></div>
              </div>
            } @else {
              <div class="is-readonly">---</div>
            }
          </div>
        }
      </div>
    }
  </div>
}
<topo-modal
  [isActive]="showMultilineTextDialog"
  (close)="multilineClose()"
  [width]="875"
  backgroundCanClose="true"
  paddingClass="modal-box"
  [isCard]="true">
  <div class="modal-header">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <h5>{{ field.displayName }}</h5>
      <div
        (click)="multilineClose()"
        style="cursor: pointer">
        <i
          class="icon icon-close-X"
        style="color: var(--text-color-3)"></i>
      </div>
    </div>
  </div>
  <div
    class="modal-body ngx-quill-view"
    [ngClass]="{ 'is-dark': userPref.isDarkTheme() }">
    <div class="ql-editor" [innerHTML]="_value | safeHtml"></div>
  </div>
</topo-modal>
